import _ from 'underscore';
import SequencerOperation from "models/audioEditor/sequencerOperation/SequencerOperation";


const ChangeSpeakerForParagraphOperation =  SequencerOperation.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        SequencerOperation.apply(this, [attributes, options]);
    },

    execute : function(_paragraphContainerView, newSpeakerInfo, startSequencerNodeToChange, endSequencerNodeToChange, arrayOfSequencerNodeToChange){
        if(!newSpeakerInfo){
            return false;
        }

        const targetSequencerNodes = this._getTargetSequencerNodes(
            startSequencerNodeToChange,
            endSequencerNodeToChange,
            arrayOfSequencerNodeToChange,
        );
        const arrayOfSpeakerWritableSequencerNodes = this._getSpeakerWritableSequencerNodes(targetSequencerNodes);
        if(arrayOfSpeakerWritableSequencerNodes.length === 0){
            return false;
        }

        const sequencerNodeCidArray = this._getSequencerNodeCidArray(arrayOfSpeakerWritableSequencerNodes);
        const sequencerNodeCidToOldSpeakerId = this._getSequencerNodeCidToOldSpeakerId(arrayOfSpeakerWritableSequencerNodes);
        this._changeSpeakerParagraph(arrayOfSpeakerWritableSequencerNodes, newSpeakerInfo);
        this.getSequencer().getHistoryManagement().addSequencerOperationChangeSpeakerForParagraphOperationLog(sequencerNodeCidArray, sequencerNodeCidToOldSpeakerId, newSpeakerInfo);
        this._notifyParagraphStructureChanged();
        return true;
    },

    _getTargetSequencerNodes : function(startSequencerNodeToChange, endSequencerNodeToChange, arrayOfSequencerNodeToChange){
        if(Array.isArray(arrayOfSequencerNodeToChange)){
            return arrayOfSequencerNodeToChange.reduce((uniqueSequencerNodes, sequencerNode)=>{
                if(sequencerNode && !uniqueSequencerNodes.includes(sequencerNode)){
                    uniqueSequencerNodes.push(sequencerNode);
                }
                return uniqueSequencerNodes;
            }, []);
        }
        if(this.isStartNodeAndEndNodeConnected(startSequencerNodeToChange, endSequencerNodeToChange)){
            return this.getArrayOfSequencerNodes(startSequencerNodeToChange, endSequencerNodeToChange);
        }
        return [];
    },

    _canPersistSpeakerInfoOnSequencerNode : function(sequencerNode){
        if(!sequencerNode){
            return false;
        }
        if(sequencerNode.isWrapNode && sequencerNode.isWrapNode()){
            return false;
        }
        const audioSegment = sequencerNode.getAudioSegment ? sequencerNode.getAudioSegment() : null;
        return !!(audioSegment && typeof audioSegment.setSpeakerInfo === "function");
    },

    _getSpeakerWritableSequencerNodes : function(arrayOfSequencerNodeToChange){
        return (arrayOfSequencerNodeToChange || []).filter((sequencerNode)=>{
            return this._canPersistSpeakerInfoOnSequencerNode(sequencerNode);
        });
    },

    _getSequencerNodeCidArray : function(arrayOfSequencerNodeToChange){
        return arrayOfSequencerNodeToChange.map((sequencerNode)=>{
            return sequencerNode.cid;
        });
    },

    _getSequencerNodeCidToOldSpeakerId : function(arrayOfSequencerNodeToChange){
        return arrayOfSequencerNodeToChange.reduce((sequencerNodeCidToOldSpeakerId, sequencerNode)=>{
            const speakerInfo = sequencerNode && sequencerNode.getAudioSegment ? sequencerNode.getAudioSegment().getSpeakerInfo() : null;
            sequencerNodeCidToOldSpeakerId[sequencerNode.cid] = speakerInfo ? speakerInfo.getSpeakerId() : null;
            return sequencerNodeCidToOldSpeakerId;
        }, {});
    },

    _getArrayOfSequencerNodesFromCidArray : function(sequencerNodeCidArray){
        const resolvedSequencerNodes = [];
        for(let i = 0; i < sequencerNodeCidArray.length; i++){
            const sequencerNode = this.getSequencer().getSequencerNodeByNodeCid(sequencerNodeCidArray[i]);
            if(!sequencerNode){
                return null;
            }
            resolvedSequencerNodes.push(sequencerNode);
        }
        return resolvedSequencerNodes;
    },

    _changeSpeakerParagraph : function(arrayOfSequencerNodeToChange, newSpeakerInfo){
        arrayOfSequencerNodeToChange.forEach((sequencerNode)=>{
            sequencerNode.getAudioSegment().setSpeakerInfo(newSpeakerInfo);
        });
    },

    _restoreSpeakerInfo : function(arrayOfSequencerNodeToChange, sequencerNodeCidToOldSpeakerId){
        arrayOfSequencerNodeToChange.forEach((sequencerNode)=>{
            const speakerId = sequencerNodeCidToOldSpeakerId ? sequencerNodeCidToOldSpeakerId[sequencerNode.cid] : null;
            const oldSpeakerInfo = this.getSequencer().getSpeakerInfoBySpeakerId(speakerId);
            sequencerNode.getAudioSegment().setSpeakerInfo(oldSpeakerInfo);
        });
    },

    undo : function(sequencerOperationChangeSpeakerForParagraphOperationLog ){
        const sequencerNodeCidArray = sequencerOperationChangeSpeakerForParagraphOperationLog.getSequencerNodeCidArray();
        const sequencerNodeCidToOldSpeakerId = sequencerOperationChangeSpeakerForParagraphOperationLog.getSequencerNodeCidToOldSpeakerId();
        const arrayOfSequencerNodeToChange = this._getArrayOfSequencerNodesFromCidArray(sequencerNodeCidArray);
        if(!arrayOfSequencerNodeToChange){
            console.warn("ChangeSpeakerForParagraphOperation: aborting undo because one or more logged CIDs no longer resolve");
            return;
        }
        this._restoreSpeakerInfo(arrayOfSequencerNodeToChange, sequencerNodeCidToOldSpeakerId);
        this._notifyParagraphStructureChanged();
    },

    redo: function(sequencerOperationChangeSpeakerForParagraphOperationLog){
        const newSpeakerId = typeof sequencerOperationChangeSpeakerForParagraphOperationLog.getNewSpeakerId === "function"
            ? sequencerOperationChangeSpeakerForParagraphOperationLog.getNewSpeakerId()
            : null;
        const newSpeakerInfo = newSpeakerId
            ? this.getSequencer().getSpeakerInfoBySpeakerId(newSpeakerId)
            : sequencerOperationChangeSpeakerForParagraphOperationLog.getNewSpeakerInfo();
        if(!newSpeakerInfo){
            console.warn("ChangeSpeakerForParagraphOperation: aborting redo because speaker is no longer in the sequencer registry", {newSpeakerId});
            return;
        }
        const sequencerNodeCidArray = sequencerOperationChangeSpeakerForParagraphOperationLog.getSequencerNodeCidArray();
        const arrayOfSequencerNodeToChange = this._getArrayOfSequencerNodesFromCidArray(sequencerNodeCidArray);
        if(!arrayOfSequencerNodeToChange){
            console.warn("ChangeSpeakerForParagraphOperation: aborting redo because one or more logged CIDs no longer resolve");
            return;
        }
        this._changeSpeakerParagraph(arrayOfSequencerNodeToChange, newSpeakerInfo);
        this._notifyParagraphStructureChanged();
    },

});


export default ChangeSpeakerForParagraphOperation;
